"use client";
import {
  useDialogStoreProps
} from "./I62TROYO.js";
import {
  useStore,
  useStoreProps
} from "./EKQEJRUF.js";
import {
  useUpdateEffect
} from "./6O5OEQGF.js";

// src/popover/popover-store.ts
import * as Core from "@ariakit/core/popover/popover-store";
function usePopoverStoreProps(store, update, props) {
  useUpdateEffect(update, [props.popover]);
  useStoreProps(store, props, "placement");
  return useDialogStoreProps(store, update, props);
}
function usePopoverStore(props = {}) {
  const [store, update] = useStore(Core.createPopoverStore, props);
  return usePopoverStoreProps(store, update, props);
}

export {
  usePopoverStoreProps,
  usePopoverStore
};
